import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const CheckIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 13" },
        React.createElement("path", { d: "M4.70989 12.0605L0.807172 8.15822C0.611892 7.96296 0.611882 7.64636 0.807152 7.45109L1.51411 6.74413C1.70936 6.54888 2.02592 6.54887 2.22119 6.7441L5.06344 9.58591L13.9711 0.677767C14.1664 0.482497 14.483 0.482487 14.6782 0.677767L15.3852 1.38472C15.5805 1.57998 15.5805 1.89656 15.3852 2.09182L5.41698 12.0605C5.22173 12.2557 4.90515 12.2558 4.70988 12.0605H4.70989Z" })));
};

export { CheckIcon };
//# sourceMappingURL=CheckIcon.esm.js.map
